import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import Scanlines from '../components/Scanlines';
import SocialLinks from '../components/SocialLinks';
import { albumData } from '../mock';

const Home = () => {
  const navigate = useNavigate();

  const menuItems = [
    { label: 'MERCH', path: albumData.merchUrl, external: true },
    { label: 'CONTACT', path: '/contact', external: false }
  ];

  const handleMenuClick = (item) => {
    if (item.external) {
      window.open(item.path, '_blank');
    } else {
      navigate(item.path);
    }
  };

  return (
    <div className="home-container">
      <Scanlines />
      
      <div className="home-content">
        {/* Main Album Section */}
        <div className="album-section">
          <div className="album-image-wrapper">
            <img 
              src={albumData.image} 
              alt={albumData.title}
              className="album-image"
            />
          </div>
          
          <h2 className="album-subtitle">{albumData.title}</h2>
          
          <div className="album-links">
            <button 
              onClick={() => navigate(albumData.listenUrl)}
              className="album-link"
            >
              LISTEN NOW
            </button>
            <a 
              href={albumData.vinylUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="album-link"
            >
              CD EDITION
            </a>
          </div>
        </div>

        {/* Menu List */}
        <div className="menu-list">
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={() => handleMenuClick(item)}
              className="menu-item"
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* Social Links */}
        <SocialLinks />
      </div>
    </div>
  );
};

export default Home;
